import { useTranslation } from 'react-i18next';
import HomepageHeader from '@/enterprise/components/HomepageHeader';
import OfferActivityCards from '@/enterprise/components/OfferActivity/OfferActivityCards';
import { OfferActivityFilterProvider } from '@/enterprise/components/OfferActivity/OfferActivityFilterContext';
import OfferActivityFilters from '@/enterprise/components/OfferActivity/OfferActivityFilters';
import OfferActivitySummary from '@/enterprise/components/OfferActivity/OfferActivitySummary';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import useTakerMarkets from '@/enterprise/data/useTakerMarkets';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

const OfferActivityComponent = () => {
  const { t } = useTranslation();
  const { data: takerMarkets } = useTakerMarkets();

  return (
    <>
      <HomepageHeader title={t('core.offerActivity')} />
      <OfferActivityFilterProvider takerMarkets={takerMarkets}>
        <div className="space-y-6">
          <OfferActivitySummary />
          <OfferActivityFilters />
          <OfferActivityCards />
        </div>
      </OfferActivityFilterProvider>
    </>
  );
};

const OfferActivity = () => {
  const enableUnification = useEnableUnification();

  if (!enableUnification) {
    return <NavigateWithRedirect to={asEnterpriseLink('customers')} />;
  }

  return (
    <QueryBoundaries>
      <OfferActivityComponent />
    </QueryBoundaries>
  );
};

export default OfferActivity;
